import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import {
    ArrowRight, CalendarClock, Check, ChevronDown, Clapperboard, Facebook, FileCheck2, Layers,
    Link2, Menu, MonitorSmartphone, MousePointerClick, PackageOpen, PenLine, Play, Send,
    ShoppingBag, SlidersHorizontal, Smartphone, Sparkles, Store, Users, Video, Wand2, X,
} from 'lucide-react';
import { db } from '../firebase';
import { PAKEJ } from '../utils/pakejV4';
import { FAQS } from '../utils/faqSesaat';
import './LandingV4.css';

/* ═══════════════════════════════════════════════════════════════
   LandingV4View — PROTOTAIP landing page v4 (arahan user 2026-10-31)
   ───────────────────────────────────────────────────────────────
   Tema glass warna cair (CSS awalan `lv4-`). Harga + isi pakej DIBACA
   dari utils/pakejV4.js supaya dua halaman tidak berbeza.

   ⛔ Route /landing-v4 hanya wujud di localhost (dipagar import.meta.env.DEV
      dalam App.jsx). Butang langgan ke /pricing-v4 — BELUM ke bayaran, kerana
      server masih mengenakan harga LIVE (lihat nota PricingV4View).
   ⛔ Testimoni dalam SalesPageView SENGAJA tidak disalin: gambar buktinya
      stok Unsplash. Masukkan hanya testimoni + bukti pelanggan sebenar.
   ⚠️ Kad "Sedang dibina" = ciri belum sampai pelanggan. Bila ciri lancar,
      pindahkan ke FEATURES; jangan biarkan ia dijual sebagai sudah ada.
   ═══════════════════════════════════════════════════════════════ */

const LANGKAH_HERO = [
    [Link2, 'Import produk', 'Link TikTok diterima'],
    [PenLine, 'Tulis skrip', 'Hook dan caption siap'],
    [Clapperboard, 'Jana video', 'Google Flow sedang berjalan'],
    [CalendarClock, 'Jadual post', 'TikTok, 8:30 malam'],
];

const KAPASITI = [
    ['5', 'module siap pakai'],
    ['100', 'Generate sehari'],
    ['≈300', 'video sehari'],
    ['6', 'browser, pakej Fighter'],
];

const BANDING = [
    ['Cari idea hook untuk setiap produk', 'Skrip, hook dan caption ditulis AI mengikut module'],
    ['Rakam, sunting, ulang setiap hari', 'Video dijana melalui Google Flow, tanpa CapCut'],
    ['Video nampak sama seperti pesaing', 'Tiga set idea dan lima gaya untuk satu produk'],
    ['Post satu demi satu mengikut masa', 'Jadual kalendar, robot post sendiri'],
    ['Tag produk terlepas tanpa disedari', 'Produk gagal ditag? Video kekal sebagai draf'],
];

const CARA = [
    [PackageOpen, 'Masukkan produk', 'Tampal link TikTok atau Shopee. Satu produk atau sekumpulan sekali gus.'],
    [Layers, 'Pilih module', 'Tentukan gaya video yang sesuai dengan produk dan akaun anda.'],
    [Wand2, 'Generate & Run', 'AI menulis prompt, robot menjalankan Google Flow untuk gambar dan video.'],
    [Send, 'Jadual & post', 'Susun di kalendar. TikTok dan Facebook Reels dipost mengikut masa anda.'],
];

const MODULE = [
    { nama: 'AI8SAAT', babak: '1 babak', gaya: 'Avatar menerangkan masalah dan produk secara terus.', poster: '/salespage/thumbs/ai8saat.avif' },
    { nama: 'AI16SAAT', babak: '2 babak', gaya: 'Cerita lebih panjang, dua scene digabungkan automatik.', poster: '/salespage/thumbs/ai16saat.avif', video: '/salespage/thumbs/ai16saat-360.mp4' },
    { nama: 'GOYANG', babak: 'Tanpa avatar', gaya: 'Tangan memegang produk, berasaskan template siap.', poster: '/salespage/thumbs/goyang.avif' },
    { nama: 'Home Niche', babak: 'Niche rumah', gaya: 'Dibina khusus untuk produk kegunaan rumah.', poster: '/salespage/thumbs/homeniche.avif' },
    { nama: 'SMART', babak: '1 atau 2 babak', gaya: 'Gunakan prompt sendiri atau GPT dan Gem anda.', poster: '/salespage/thumbs/smartcustom.avif', video: '/salespage/thumbs/smartcustom-360.mp4' },
];

const CIRI = [
    { Ikon: MousePointerClick, tajuk: 'Satu klik, semua berjalan', isi: 'Tick semua kad dan tekan Run. Generate, Run dan Retry dibuat secara pukal.', luas: true, warna: 'langit' },
    { Ikon: ShoppingBag, tajuk: 'Import TikTok & Shopee', isi: 'Tarik produk terus ke My Products, termasuk link affiliate Shopee.', warna: 'pudina' },
    { Ikon: CalendarClock, tajuk: 'Kalendar post', isi: 'Satu kalendar untuk melihat apa yang dipost dan bila.', warna: 'lilac' },
    { Ikon: Facebook, tajuk: 'Facebook Reels', isi: 'Satu video, dua platform. Reel dijadualkan bersama link produk.', warna: 'pic' },
    { Ikon: Sparkles, tajuk: 'Agent Saya', isi: 'Sambungkan ChatGPT atau Gemini sendiri. SESAAT mengambil prompt dan memasukkannya ke kad.', luas: true, warna: 'lilac' },
    { Ikon: FileCheck2, tajuk: 'Selamat tanpa pengawasan', isi: 'Kalau produk gagal ditag, video kekal sebagai draf, bukan post kosong.', warna: 'pudina' },
    { Ikon: MonitorSmartphone, tajuk: 'Banyak akaun', isi: '3 browser untuk Premium, 6 untuk Fighter. Setiap satu untuk akaun berasingan.', luas: true, warna: 'langit' },
    { Ikon: SlidersHorizontal, tajuk: 'Pro Mode', isi: 'Mahu kawalan penuh? Ubah gaya setiap set dan bina prompt mengikut blok.', luas: true, warna: 'pic' },
];

const SEDANG_DIBINA = [
    [Wand2, 'Workspace v4', 'Pilih module, gaya, scene, model dan avatar dalam satu tempat.'],
    [Users, 'Module Partner', 'Module baharu oleh rakan creator, supaya video anda lain daripada yang lain.'],
    [Clapperboard, 'Hosted Flow', 'Video dijana untuk anda di server kami, tanpa extension.'],
    [Smartphone, 'Automation telefon', 'Post ke Shopee Video terus melalui telefon Android.'],
];

const SEGMEN = [
    [Link2, 'Ejen affiliate', 'Banyak produk, banyak video, komisen dari lebih banyak peluang.'],
    [Store, 'Peniaga', 'Kandungan harian untuk produk sendiri tanpa kos krew.'],
    [Video, 'Creator UGC', 'Hasilkan lebih banyak idea tanpa perlu muncul depan kamera.'],
    [Users, 'Agensi & team', 'Urus beberapa akaun dalam satu sistem yang sama.'],
];

const FAQ_V4 = [
    { q: 'Adakah saya perlu akaun Google Flow sendiri?', a: 'Ya. Semua pakej tidak termasuk akaun Google Flow. SESAAT menyediakan robot Flow automation yang berjalan menggunakan akaun anda.' },
    { q: 'Apa yang perlu saya sediakan untuk bermula?', a: 'Komputer dengan browser Chrome, extension SESAAT yang dimuat turun dari dashboard, akaun Google Flow dan akaun TikTok atau Facebook anda.' },
    ...FAQS.filter((f) => !f.q.startsWith('Apakah modul')).map(({ q, a }) => ({ q, a })),
];

const NAV = [['#cara', 'Cara kerja'], ['#module', 'Module'], ['#ciri', 'Ciri'], ['#harga', 'Harga'], ['#soalan', 'Soalan']];

function Logo() {
    return (
        <span className="lv4-logo">
            <span className="lv4-logo-tanda"><Sparkles size={15} strokeWidth={2.4} /></span>
            SESAAT
        </span>
    );
}

function PanelHero() {
    const [aktif, setAktif] = useState(0);

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
        const t = setInterval(() => setAktif((n) => (n + 1) % LANGKAH_HERO.length), 2200);
        return () => clearInterval(t);
    }, []);

    return (
        <div className="lv4-pentas" aria-label="Contoh paparan SESAAT">
            <div className="lv4-panel lv4-kaca">
                <div className="lv4-panel-kepala">
                    <span className="lv4-titik" /><span className="lv4-titik" /><span className="lv4-titik" />
                    <b>Workspace</b>
                    <em>Contoh paparan</em>
                </div>
                <div className="lv4-produk">
                    <img src="/salespage/lgn/goyang.jpg" alt="" width="46" height="46" />
                    <div>
                        <strong>Krim tangan viral</strong>
                        <span>GOYANG · Set 1, 2, 3</span>
                    </div>
                </div>
                <ol className="lv4-langkah">
                    {LANGKAH_HERO.map(([Ikon, tajuk, status], i) => {
                        const keadaan = i < aktif ? 'siap' : i === aktif ? 'jalan' : 'nanti';
                        return (
                            <li key={tajuk} className={`lv4-langkah-baris is-${keadaan}`}>
                                <span className="lv4-langkah-ikon">
                                    {keadaan === 'siap' ? <Check size={15} strokeWidth={2.8} /> : <Ikon size={15} strokeWidth={2} />}
                                </span>
                                <span className="lv4-langkah-teks">
                                    <strong>{tajuk}</strong>
                                    <small>{keadaan === 'nanti' ? 'Menunggu' : status}</small>
                                </span>
                            </li>
                        );
                    })}
                </ol>
            </div>
            <div className="lv4-telefon">
                <video src="/salespage/thumbs/ai16saat-360.mp4" poster="/salespage/thumbs/ai16saat.avif" autoPlay muted loop playsInline preload="metadata" />
                <span className="lv4-telefon-label"><Play size={11} fill="currentColor" /> AI16SAAT</span>
            </div>
        </div>
    );
}

function KadModule({ m }) {
    return (
        <article className="lv4-modul">
            <div className="lv4-modul-media">
                {m.video
                    ? <video src={m.video} poster={m.poster} autoPlay muted loop playsInline preload="none" />
                    : <img src={m.poster} alt={`Contoh video ${m.nama}`} loading="lazy" />}
                <span>{m.babak}</span>
            </div>
            <h3>{m.nama}</h3>
            <p>{m.gaya}</p>
        </article>
    );
}

function KadHarga({ pakej, onPilih }) {
    const { Ikon } = pakej;
    return (
        <article className={`lv4-harga lv4-kaca ${pakej.popular ? 'is-popular' : ''}`}>
            {(pakej.popular || pakej.lencana) && <span className="lv4-harga-lencana">{pakej.popular ? 'Paling popular' : pakej.lencana}</span>}
            <div className="lv4-harga-nama"><span><Ikon size={18} strokeWidth={1.9} /></span>{pakej.nama}</div>
            <p className="lv4-harga-huraian">{pakej.huraian}</p>
            <div className="lv4-harga-nilai">
                <strong>{pakej.harga}</strong>
                {pakej.tempoh && <span>{pakej.tempoh}</span>}
                {pakej.hargaLama && <s>{pakej.hargaLama}</s>}
            </div>
            <p className="lv4-harga-nota">{pakej.nota}</p>
            <button type="button" className={pakej.popular ? 'lv4-btn lv4-btn-utama' : 'lv4-btn lv4-btn-kaca'} onClick={() => onPilih(pakej)}>
                {pakej.cta}
            </button>
            <ul>
                {pakej.isi.map(([IkonBaris, label, nilai]) => (
                    <li key={label}>
                        <span><IkonBaris size={14} strokeWidth={1.8} />{label}</span>
                        <b>{nilai}</b>
                    </li>
                ))}
            </ul>
            <p className="lv4-harga-syarat">{pakej.syarat}</p>
        </article>
    );
}

export default function LandingV4View() {
    const navigate = useNavigate();
    const [menuBuka, setMenuBuka] = useState(false);
    const [faqBuka, setFaqBuka] = useState(0);
    const [bilPengguna, setBilPengguna] = useState(null);

    useEffect(() => {
        let batal = false;
        getDoc(doc(db, 'public_stats', 'summary'))
            .then((snap) => {
                const c = snap.exists() ? snap.data().userCount : null;
                if (!batal && typeof c === 'number' && c > 0) setBilPengguna(c);
            })
            .catch(() => { /* senyap — kekal teks sandaran, sama seperti SalesPageView */ });
        return () => { batal = true; };
    }, []);

    const keLogin = () => navigate('/login');
    const pilihPakej = (p) => (p.id === 'trial' ? keLogin() : navigate('/pricing-v4'));

    return (
        <div className="lv4">
            <div className="lv4-latar" aria-hidden="true" />

            <p className="lv4-prototaip">Prototaip v4. Butang belum disambung ke bayaran.</p>

            <header className="lv4-nav lv4-kaca">
                <a href="#atas" aria-label="SESAAT"><Logo /></a>
                <nav className="lv4-nav-pautan" aria-label="Navigasi utama">
                    {NAV.map(([href, label]) => <a key={href} href={href}>{label}</a>)}
                </nav>
                <div className="lv4-nav-kanan">
                    <button type="button" className="lv4-nav-log" onClick={keLogin}>Log masuk</button>
                    <button type="button" className="lv4-btn lv4-btn-utama lv4-btn-kecil" onClick={keLogin}>Cuba percuma</button>
                    <button type="button" className="lv4-nav-menu" aria-label={menuBuka ? 'Tutup menu' : 'Buka menu'} aria-expanded={menuBuka} onClick={() => setMenuBuka(!menuBuka)}>
                        {menuBuka ? <X size={20} /> : <Menu size={20} />}
                    </button>
                </div>
                {menuBuka && (
                    <nav className="lv4-nav-mudah" aria-label="Navigasi telefon">
                        {NAV.map(([href, label]) => <a key={href} href={href} onClick={() => setMenuBuka(false)}>{label}</a>)}
                    </nav>
                )}
            </header>

            <main id="atas">
                <section className="lv4-hero">
                    <div className="lv4-hero-teks">
                        <p className="lv4-pil">{bilPengguna ? bilPengguna.toLocaleString('en-MY') : '1,000+'} ejen affiliate guna SESAAT</p>
                        <h1>Video yang laku, <em>bukan salinan orang lain.</em></h1>
                        <p className="lv4-hero-sub">
                            Masukkan link produk. SESAAT menulis skrip, menjana video melalui Google Flow
                            dan post ke TikTok serta Facebook Reels mengikut jadual anda.
                        </p>
                        <div className="lv4-hero-cta">
                            <button type="button" className="lv4-btn lv4-btn-utama" onClick={keLogin}>
                                Cuba dengan 5 coin percuma <ArrowRight size={17} />
                            </button>
                            <a className="lv4-btn lv4-btn-kaca" href="#cara">Lihat cara kerja</a>
                        </div>
                        <p className="lv4-hero-kecil">Tiada kad kredit. Premium dari RM99 sebulan.</p>
                    </div>
                    <PanelHero />
                </section>

                <section className="lv4-kapasiti lv4-kaca" aria-label="Kapasiti SESAAT">
                    {KAPASITI.map(([nilai, label]) => (
                        <div key={label}><strong>{nilai}</strong><span>{label}</span></div>
                    ))}
                </section>

                <section className="lv4-seksyen lv4-sempit">
                    <div className="lv4-kepala">
                        <h2>Kerja yang memenatkan, <em>kami ambil alih.</em></h2>
                        <p>Masa anda patut pergi kepada memilih produk yang laku, bukan mengulang kerja yang sama.</p>
                    </div>
                    <div className="lv4-banding lv4-kaca">
                        <div className="lv4-banding-kepala"><span>Cara biasa</span><span>Dengan SESAAT</span></div>
                        {BANDING.map(([lama, baru]) => (
                            <div className="lv4-banding-baris" key={lama}>
                                <p>{lama}</p>
                                <p><Check size={16} strokeWidth={2.6} />{baru}</p>
                            </div>
                        ))}
                    </div>
                </section>

                <section id="cara" className="lv4-seksyen">
                    <div className="lv4-kepala">
                        <h2>Dari link produk ke post, <em>dalam empat langkah.</em></h2>
                    </div>
                    <ol className="lv4-cara">
                        {CARA.map(([Ikon, tajuk, isi], i) => (
                            <li key={tajuk} className="lv4-kaca">
                                <span className="lv4-cara-no">{i + 1}</span>
                                <Ikon size={22} strokeWidth={1.8} />
                                <h3>{tajuk}</h3>
                                <p>{isi}</p>
                            </li>
                        ))}
                    </ol>
                </section>

                <section id="module" className="lv4-seksyen">
                    <div className="lv4-kepala">
                        <h2>Lima gaya video. <em>Satu produk, banyak sudut.</em></h2>
                        <p>Setiap module dibina daripada teknik jualan yang berbeza, dan setiap Generate memberi tiga set idea.</p>
                    </div>
                    <div className="lv4-modul-grid">
                        {MODULE.map((m) => <KadModule key={m.nama} m={m} />)}
                    </div>
                </section>

                <section id="ciri" className="lv4-seksyen">
                    <div className="lv4-kepala">
                        <h2>Satu sistem, <em>dari idea sampai post.</em></h2>
                    </div>
                    <div className="lv4-bento">
                        {CIRI.map(({ Ikon, tajuk, isi, luas, warna }) => (
                            <article key={tajuk} className={`lv4-ciri lv4-kaca warna-${warna} ${luas ? 'is-luas' : ''}`}>
                                <span className="lv4-ciri-ikon"><Ikon size={20} strokeWidth={1.8} /></span>
                                <h3>{tajuk}</h3>
                                <p>{isi}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="lv4-seksyen lv4-dibina">
                    <div className="lv4-kepala">
                        <h2>Sedang dibina untuk <em>v4.</em></h2>
                        <p>Ciri berikut masih dalam pembangunan dan belum tersedia kepada pelanggan.</p>
                    </div>
                    <div className="lv4-dibina-grid">
                        {SEDANG_DIBINA.map(([Ikon, tajuk, isi]) => (
                            <article key={tajuk}>
                                <Ikon size={20} strokeWidth={1.8} />
                                <div>
                                    <h3>{tajuk}<span>Akan datang</span></h3>
                                    <p>{isi}</p>
                                </div>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="lv4-seksyen">
                    <div className="lv4-kepala">
                        <h2>Dibina untuk sesiapa yang <em>menjual melalui video.</em></h2>
                    </div>
                    <div className="lv4-segmen">
                        {SEGMEN.map(([Ikon, tajuk, isi]) => (
                            <article key={tajuk}>
                                <span><Ikon size={19} strokeWidth={1.8} /></span>
                                <h3>{tajuk}</h3>
                                <p>{isi}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section id="harga" className="lv4-seksyen">
                    <div className="lv4-kepala">
                        <h2>Mula percuma. <em>Naik taraf bila bersedia.</em></h2>
                        <p>Semua pakej berbayar termasuk Flow automation, TikTok auto-upload dan Import Product.</p>
                    </div>
                    <div className="lv4-harga-grid">
                        {PAKEJ.map((p) => <KadHarga key={p.id} pakej={p} onPilih={pilihPakej} />)}
                    </div>
                </section>

                <section id="soalan" className="lv4-seksyen lv4-sempit">
                    <div className="lv4-kepala">
                        <h2>Soalan <em>lazim</em></h2>
                    </div>
                    <div className="lv4-faq">
                        {FAQ_V4.map((f, i) => {
                            const buka = faqBuka === i;
                            return (
                                <div key={f.q} className={`lv4-kaca ${buka ? 'is-buka' : ''}`}>
                                    <button type="button" aria-expanded={buka} onClick={() => setFaqBuka(buka ? -1 : i)}>
                                        {f.q}<ChevronDown size={18} />
                                    </button>
                                    {buka && <p>{f.a}</p>}
                                </div>
                            );
                        })}
                    </div>
                </section>

                <section className="lv4-akhir lv4-kaca">
                    <h2>Video pertama anda boleh siap <em>hari ini.</em></h2>
                    <p>Cuba dengan 5 coin percuma. Tiada kad kredit.</p>
                    <button type="button" className="lv4-btn lv4-btn-utama" onClick={keLogin}>
                        Cuba percuma <ArrowRight size={17} />
                    </button>
                </section>
            </main>

            <footer className="lv4-kaki">
                <Logo />
                <p>© {new Date().getFullYear()} SESAAT. Hasil jualan bergantung pada produk, akaun dan usaha anda.</p>
            </footer>

            <div className="lv4-melekat lv4-kaca">
                <span><b>Premium RM99</b> / bulan</span>
                <button type="button" className="lv4-btn lv4-btn-utama lv4-btn-kecil" onClick={keLogin}>Cuba percuma</button>
            </div>
        </div>
    );
}
